var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"castle-markers"},_vm._l((_vm.layers),function(layer){return _c('mgl-geojson-layer',{attrs:{"sourceId":_vm.sourceId,"layerId":layer.id,"layer":layer,"replaceSource":"","replace":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }